import cx from 'clsx';
import React from 'react';

import styles from './SubheaderSlot.module.scss';
import { SubheaderItem } from './types';

interface SubheaderSlotProps {
  item: SubheaderItem;
  onClick: (event: React.MouseEvent<{}>) => void;
}

const isActive = (state: string) => {
  return state === 'active';
};

const SubheaderSlot = ({ item, onClick }: SubheaderSlotProps) => {
  const { title, state } = item;

  return (
    <div className={styles.slot} data-testid="subheader-slot">
      {isActive(state) && (
        <div
          className={styles.selectionElement}
          data-testid="selection-element"
        />
      )}
      <a
        className={cx(
          styles.title,
          state === 'active' ? styles.titleActive : styles.titleInactive
        )}
        data-testid="subheader-slot-anchor-title"
        target="_self"
        rel={`${item.notIndexed ? 'nofollow' : ''}`}
        href={item.route_link}
        onClick={onClick}
      >
        {title}
      </a>
    </div>
  );
};

export default SubheaderSlot;
